import consumer from "channels/consumer"
import Chartkick from "chartkick"

export default class {
  constructor(scheduleId, statusEl, chartId) {
    this.scheduleId = scheduleId
    this.statusEl = statusEl
    this.chartId = chartId
  }

  start() {
    this.subscription = consumer.subscriptions.create({ "channel": "BarReview::CourseProgressChannel", "schedule_id": this.scheduleId }, {
      received: (data) => {
        if (data.action === "update") {
          this.statusEl.outerHTML = data.statusHTML
          const chart = Chartkick.charts[this.chartId]
          chart.updateData(data.updatedData)
          consumer.subscriptions.remove(this.subscription) // the page no longer needs to subscribe for changes.
        }
      }
    })
  }
}
